<div class="main-container centered" @fadeIn>
    <p><strong>Thank you for using Vitralogy Binder</strong></p>
    <p class="secondary">A confirmation link has been sent to your work email.</p>
    <p class="secondary">Please click the link inside the email to access this binder session.</p>
</div>
